'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	(0, _jquery2.default)(document).on('click', '.activityTracker button', function () {
		var $this = (0, _jquery2.default)(this);
		$this.prop('disabled', true);
		$this.html('<i class="fa fa-circle-o-notch fa-spin"></i>');

		var home = (0, _jquery2.default)("#isHome").is(":checked");
		var url = $this.data('url');
		var id = $this.data('id');

		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function (e) {
				return activitySwitch(url, id, home, e.coords.longitude, e.coords.latitude);
			}, function (error) {
				if (error.code == error.PERMISSION_DENIED) {
					$this.prop('disabled', false);
					$this.html('<i class="fa fa-play green"></i>');
					abp.message.warn(Resx.App.AppTrackerNeedsGeolocationDescription, Resx.App.AppTrackerNeedsGeolocationTitle);
				} else {
					activitySwitch(url, id, home, null, null);
				}
			});
		} else {
			$this.prop('disabled', false);
			$this.html('<i class="fa fa-play green"></i>');
			abp.message.warn(Resx.App.AppTrackerNeedsGeolocationDescription, Resx.App.AppTrackerNeedsGeolocationTitle);
		}
	});

	function activitySwitch(url, id, home, longitude, latitude) {
		// console.log(arguments);
		(0, _jquery2.default)(".activityTracker").load(url, { activityId: id, home: home, latitude: latitude, longitude: longitude }, function (response, status, xhr) {
			if (response == "error") {
				abp.message.error(Resx.Common.AjaxError);
			}
		});
	}
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/activityTracker.js
// module id = 1050
// module chunks = 0